import { AutoField, FieldLabel } from "@measured/puck";
import { Box, useTheme } from "@mui/material";
import { t } from "i18next";
import ToggleOn from "@mui/icons-material/ToggleOn";

import NativePuckTitleField from "src/components/Puck/config/fields/NativePuckTitleField";

type PdfDownloadAvailabilityFieldProps = {
    value?: boolean;
    onChange: (value: boolean) => void;
    readOnly?: boolean;
};

export const PdfDownloadAvailabilityField = ({
    value = true,
    onChange,
    readOnly,
}: PdfDownloadAvailabilityFieldProps) => {
    const theme = useTheme();

    return (
        <Box>
            <NativePuckTitleField
                label={t("settings.cms.templates.download_availability.title", "Availability")}
                subtitle={t(
                    "settings.cms.templates.download_availability.subtitle",
                    "Control whether a validated SSQ is required before this template becomes available",
                )}
                icon="exportDownload"
            />
            <Box sx={{ pt: theme.spacing(3) }}>
                <FieldLabel
                    label={t("settings.cms.templates.download_only_on_ssq_validated", "Download only on SSQ validated")}
                    icon={<ToggleOn fontSize="small" />}
                >
                    <AutoField
                        field={{
                            type: "radio",
                            options: [
                                { label: t("common.yes", "Yes"), value: true },
                                { label: t("common.no", "No"), value: false },
                            ],
                        }}
                        onChange={(nextValue) => onChange(nextValue === true)}
                        value={value}
                        readOnly={readOnly}
                    />
                </FieldLabel>
            </Box>
        </Box>
    );
};

export default PdfDownloadAvailabilityField;
